import { VhQueryAutoWeb, VhAlgorithm, VhEventMediator } from 'vhautowebdb';
import { Component, OnInit } from '@angular/core';
// import { LanguageService } from 'vhobjects-service/src/services';
// import { FunctionService } from 'vhobjects-admin';
import { LanguageService } from 'vhobjects-service/src/services';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'app-multi-language-admin',
  templateUrl: './multi-language-admin.component.html',
  styleUrls: ['./multi-language-admin.component.scss']
})
export class AtwMultiLanguageAdmin implements OnInit {
  filtered_languages: any = []; // Danh sách ngôn ngữ filtered
  searchLanguage: any = []; // giá trị input tìm kiếm ngôn ngữ
  language_codes:any;
  default_language: any;
  multi_languages_selected:any;
  constructor(
    private vhQueryAutoWeb:VhQueryAutoWeb,
    private languageService:LanguageService,
    private vhAlgorithm:VhAlgorithm,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
  ) { }

  ngOnInit() {
    this.handleAddLanguageCode();
  }

  /**
   * xứ lý checked checkbox bộ công cụ
   * @param selectedValues
   */
  handleCustomMultiLanguage(selectedValues: string[]): void {
    // Cập nhật trạng thái `checked` của từng ngôn ngữ
    this.filtered_languages.forEach(language => {
      language.checked = selectedValues.includes(language.code) || language.code === this.default_language;
    });

    // Cập nhật danh sách ngôn ngữ đã chọn
    this.multi_languages_selected.multi_languages = this.filtered_languages
      .filter(language => language.checked)
      .map(language => ({
        code: language.code,
        name: language.name,
      }));
  }

  handleAddLanguageCode() {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $eq: 'multi_languages'} }).then((res: any) => {
      this.multi_languages_selected = res[0]
      this.default_language = res[0]?.default_language
      this.languageService.getLanguages().subscribe((languages) => {
        this.language_codes = languages.map((language) => ({
          ...language, // Giữ lại các trường gốc của từng ngôn ngữ
          checked: language.code === this.default_language?.code || (this.multi_languages_selected?.multi_languages.some(
              (selectedLanguage) => selectedLanguage.code === language.code
            ) ?? false), // Kiểm tra nếu code có trong multi_languages_selected
        }));
        this.default_language = this.language_codes.find(
          (lang) => lang.code === this.default_language?.code
        );
        this.filtered_languages= this.language_codes
    });
      this.setLanguageCodeLocalStorage();
    })
  }

  handleSelectDefaultLanguage(event: any): void {
    // Cập nhật ngôn ngữ mặc định mới
    this.default_language = event;

    // Tick ngôn ngữ mặc định mới
    this.language_codes.forEach(language => {
      if (language.code === event.code) language.checked = true;
    });
    this.filtered_languages= this.language_codes
    this.searchLanguage=''
    this.multi_languages_selected.multi_languages = this.language_codes
      .filter(language => language.checked)
      .map(language => ({
        code: language.code,
        name: language.name,
      }));
  }

  handleUpdateSetUpMultiLanguage(){
    this.vhQueryAutoWeb
      .updateSetup(this.multi_languages_selected._id, { multi_languages: this.multi_languages_selected.multi_languages, default_language: this.default_language})
      .then(()=>{
        this.setLanguageCodeLocalStorage();
        this.functionService.defaultLanguage= this.default_language.code
      })
  }

  setLanguageCodeLocalStorage() {
    // Kiểm tra và cập nhật language_code trong localStorage
    const storedLanguageCode = this.vhQueryAutoWeb.localStorageGET('language_code')?.code;
    const newLanguageCode = storedLanguageCode &&
    this.multi_languages_selected?.multi_languages.find(language => language.code === storedLanguageCode)
      ? storedLanguageCode
      : this.default_language?.code ?? 'vn';

    // Lưu lại language_code vào localStorage
    if (storedLanguageCode !== newLanguageCode) {
      this.vhQueryAutoWeb.localStorageSET('language_code', { code: newLanguageCode });
      this.functionService.selectedLanguageCode = newLanguageCode;
      this.vhEventMediator.notifyOnConfigChanged({ status: 'update-language', code: newLanguageCode });
    } else {
      this.vhEventMediator.notifyOnConfigChanged({ status: 'update-language', code: storedLanguageCode });
    }
  }

  handleSearchLanguage(key: string): void {
    if (key.trim() === '') {
      this.filtered_languages = [...this.language_codes];
    } else {
      this.filtered_languages = this.language_codes.filter(item =>
        item.name.toLowerCase().includes(key.toLowerCase())
      );
    }
  }
}
